import { Settings, Presentation} from "../../Settings";
import { ImageTransition } from "./ImageTransition";
import { ITransition } from "./ITransition";
import { ITransitionFactory, ITransitionParams, } from "./ITransitionFactory";
import { TransitionAnimationSpine } from "./TransitionAnimationSpine";
import { VideoNoSpriteTransition } from "./VideoNoSpriteTransition";
import { VideoSpriteTransition } from "./VideoSpriteTransition";
import { VideoSpriteTransitionClassicMix } from "./VideoSpriteTransitionClassicMix";
import { TransitionPIXITypeStyle, VideoSpriteTransitionParticlesPIXIFadeInFadeOut } from "./VideoSpriteTransitionParticlesPIXIFadeInFadeOut";
import { VideoSpriteTransitionParticlesPIXiMatterJS } from "./VideoSpriteTransitionParticlesPIXiMatterJS";

const transitionFactoryMap: Record<Presentation, (params: ITransitionParams) => ITransition> = {
    [Presentation.VideoGameSprite]: (params: ITransitionParams) => new VideoSpriteTransition(params),
    [Presentation.VideoCommonNoSprite]: (params: ITransitionParams) => new VideoNoSpriteTransition(params),
    [Presentation.Image]: (params: ITransitionParams) => new ImageTransition(params),
    [Presentation.VideoCommonClassic]: (params: ITransitionParams) => new VideoSpriteTransitionClassicMix(params),
    [Presentation.VideoParticleTransitionMatterJS]: (params: ITransitionParams) => new VideoSpriteTransitionParticlesPIXiMatterJS(params),
    [Presentation.VideoParticleTransitionFadeInFadeOut]: (params: ITransitionParams) => {throw "Its moved the PrepareResources and ResourcesLoaded into transition , need to use another the factory TransitionPIXIAPP"},
    [Presentation.VideoNoSprite]: (params: ITransitionParams) => new VideoNoSpriteTransition(params),
};

export class TransitionFactory implements ITransitionFactory {
    Create(params: ITransitionParams): ITransition {        
        // if(params.transitionPIXITypeStyle == TransitionPIXITypeStyle.gameStyle){
        //     return new TransitionAnimationSpine(params);    
        // }
        return transitionFactoryMap[Settings.PresentationType](params);
    }
}
